const TimesheetApprovalEmailRemindersTooltip = () => {
    return <span>
        Configure email reminder settings for timesheet approval workflows, including reminders for approvers and submitters.
    </span>
}

export default TimesheetApprovalEmailRemindersTooltip;

